// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1DLHb","legacyBtn":"MutateMid_legacyBtn__EBspR"};